<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <i class="fa-regular fa-paper-plane icon"></i>
        <span>Correio interno</span>
      </h1>
    </div>
  </div>


  <div v-if="!loading || messages.data" class="align p-4 space_title">
    <div class="card">
      <div class="p-3" id="table_filter">
        <div class="row">
          <div class="col-sm-8 mb-2 mb-sm-0">
            <InputText placeholder="Buscar" v-model="filter.search" />
          </div>
          <div class="col-sm-4">
            <SelectBox
              id="favorite"
              placeholder="Todas as mensagens"
              :items="favoriteOptions"
              v-model="filter.favorite"
              @change="changeFilter('favorite', filter.favorite)"
            />
          </div>
        </div>
      </div>

      <table>
        <tbody>
          <tr v-for="(message, key) in messages.data" :key="key" @click="navigateToMessage(message.id)" :class="message.read ? 'read' : 'not_read'">
            <td>
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  {{ message.title }}
                  <small class="date">{{ $dateFormat(message.created_at) }}</small>
                </div>
                <i v-if="message.favorite" class="fa-solid fa-star favorite-icon"></i>
              </div>
            </td>
          </tr>
          <tr class="no_result" v-if="!messages.data || (messages.data && !messages.data.length)">
            <td colspan="10">
              Nenhum resultado encontrado
            </td>
          </tr>
        </tbody>
      </table>
    </div>


    <ListPagination class="mt-4" :links="messages.meta.links" />
  </div>
</template>
  
<script setup>
import { onBeforeMount, ref, watch } from 'vue';
import { useMessageStore } from '@/stores/MessageStore'
import { storeToRefs } from 'pinia';
import ListPagination from '@/components/ListPagination.vue'
import { inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import InputText from '@/components/InputText.vue'
import SelectBox from '@/components/SelectBox.vue'

const loader = inject('$loader');
const loading = ref(false);

const router = useRouter();
const route = useRoute();
const messageStore = useMessageStore();
const { filter, messages } = storeToRefs(messageStore);

const favoriteOptions = ref([
  { id: null, name: 'Todas as mensagens' },
  { id: 1, name: 'Mensagens favoritas' },
]);


onBeforeMount(() => {
  if (route.query.search) {
    messageStore.filter.search = route.query.search;
  }

    messageStore.filter.favorite = route.query.favorite;
    messageStore.filter.read = null;

  loadMessages();
});

watch(() => route.query.page, (newPage, oldPage) => {
  if (newPage !== oldPage) {
    window.scrollTo(0, 0);
    loadMessages();
  }
});

watch(() => messageStore.filter.search, debounce(() => {
  const new_query = { ...route.query, page: 1, search: messageStore.filter.search };
  router.push({ query: new_query }).then(() => {
    loadMessages();
  });
}, 500));

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
 
async function loadMessages() {
  loader.show();
  loading.value = true;
  messageStore.filter.page = route.query.page ? parseInt(route.query.page) : null;
  messageStore.filter.limit = 10;

  await messageStore.getMessages();
  loader.hide();
  loading.value = false;
}

function changeFilter(param, value) {
  router.push({ query: { ...route.query, page: undefined, [param]: value } });
  loadMessages();
}

function navigateToMessage(id) {
  router.push({ name: 'message', params: { id: id }});
}
</script>

<style scoped>
.date {
  display: block;
  color: #929292;
}

.read {
  color: #717171;
}

.dark .read {
  color: #8f92a7;
}

.not_read td {
  background-color: #fafbff;
  font-weight: 500;
}

.not_read:hover td {
  background-color: #e4e6f0;
}

.dark .not_read td {
  background-color: #232932;
  font-weight: 500;
}

.dark .not_read:hover td {
  background-color: #1e232b;
}

tr {
  cursor: pointer;
}

.favorite-icon {
  color: #f5b301;
  font-size: 0.85rem;
  flex-shrink: 0;
}
</style>